export default [
  {
    // =============================================================================
    // PROJECT LAYOUT ROUTES
    // =============================================================================
    path: "/project/:proj_id",
    component: () => import("@/layouts/ProjectLayout.vue"),
    meta: {
      authRequired: true,
    },
    redirect: "/project/:proj_id/home",
    children: [
      // 프로젝트
      {
        path: "back",
        name: "project-back",
        redirect: "/home",
      },
      // 대시보드
      {
        path: "home",
        name: "project-home",
        component: () => import("@/views/project/ProjectHome.vue"),
        meta: {
          topBanner: true,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            {
              title: "Home",
              active: true,
            },
          ],
          pageTitle: "Home",
          deviceRequired: true,
        },
      },
      // 대시보드
      {
        path: "dashboard",
        name: "project-dashboard",
        component: () => import("@/views/project/Dashboard.vue"),
        meta: {
          topBanner: true,
          breadcrumb: [
            {
              title: "dashboard",
              url: "/dashboard",
            },
            {
              title: "대시보드",
              active: true,
            },
          ],
          pageTitle: "대시보드",
          deviceRequired: true,
        },
      },
      // 대시보드 상세보기
      {
        path: "graph/:boardId",
        name: "project-graph",
        component: () => import("@/views/graph/Index"),
        meta: {
          deviceRequired: true,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            {
              title: "대시보드",
              active: true,
            },
          ],
          pageTitle: "대시보드",
        },
      },
      {
        path: "map",
        name: "project-map",
        meta: {},
        component: () => import("@/views/map/Map.vue"),
      },
      //fira
      {
        path: "graph-detail/:graphId",
        name: "project-graph-detail",
        component: () => import("@/views/graph-detail/Index"),
        meta: {
          deviceRequired: true,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            {
              title: "대시보드",
              active: true,
            },
          ],
          pageTitle: "대시보드",
        },
      },

      // 커뮤니티
      {
        path: "community/businessnews",
        name: "project-community-businessnews",
        component: () => import("@/views/community/CommunityBusinessnews.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "안전보건관리책임자 지시사항" },
            { title: "목록", active: true },
          ],
          pageTitle: "안전보건관리책임자 지시사항",
          activeCode: "community_businessnews",
        },
      },
      {
        // 커뮤니티 / 안전보건관리(총괄)책임자 지시사항
        path: "community/businessnews/create",
        name: "project-community-businessnews-create",
        component: () => import("@/views/community/CommunityBusinessnewsCreate.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "안전보건관리책임자 지시사항" },
            { title: "작성", active: true },
          ],
          pageTitle: "안전보건관리책임자 지시사항",
          activeCode: "community_businessnews",
        },
      },
      {
        // 커뮤니티 / 안전보건관리(총괄)책임자 지시사항
        path: "community/businessnews/:postId",
        name: "project-community-businessnews-detail",
        component: () => import("@/views/community/CommunityBusinessnewsDetail.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "안전보건관리책임자 지시사항" },
            { title: "상세", active: true },
          ],
          pageTitle: "안전보건관리책임자 지시사항",
          activeCode: "community_businessnews",
        },
      },
      {
        // 커뮤니티 / 안전보건관리(총괄)책임자 지시사항
        path: "community/businessnews/:postId/update",
        name: "project-community-businessnews-update",
        component: () => import("@/views/community/CommunityBusinessnewsUpdate.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "안전보건관리책임자 지시사항" },
            { title: "수정", active: true },
          ],
          pageTitle: "안전보건관리책임자 지시사항",
          activeCode: "community_businessnews",
        },
      },
      {
        // 커뮤니티 / 안전보건관리(총괄)책임자 지시사항
        path: "community/businessnews/:postId/reply",
        name: "project-community-businessnews-reply",
        component: () => import("@/views/community/CommunityBusinessnewsReply.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "안전보건관리책임자 지시사항" },
            { title: "답글 작성", active: true },
          ],
          pageTitle: "안전보건관리책임자 지시사항",
          activeCode: "community_businessnews",
        },
      },
      {
        path: "community/qna",
        name: "project-community-qna",
        component: () => import("@/views/community/CommunityQna.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "Q&A" },
            { title: "목록", active: true },
          ],
          pageTitle: "Q&A",
          activeCode: "community_qna",
        },
      },
      {
        // 커뮤니티 / Q&A
        path: "community/qna/create",
        name: "project-community-qna-create",
        component: () => import("@/views/community/CommunityQnaCreate.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "Q&A" },
            { title: "작성", active: true },
          ],
          pageTitle: "Q&A",
          activeCode: "community_qna",
        },
      },
      {
        // 커뮤니티 / Q&A
        path: "community/qna/:postId",
        name: "project-community-qna-detail",
        component: () => import("@/views/community/CommunityQnaDetail.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "Q&A" },
            { title: "상세", active: true },
          ],
          pageTitle: "Q&A",
          activeCode: "community_qna",
        },
      },
      {
        // 커뮤니티 / Q&A
        path: "community/qna/:postId/update",
        name: "project-community-qna-update",
        component: () => import("@/views/community/CommunityQnaUpdate.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "Q&A" },
            { title: "수정", active: true },
          ],
          pageTitle: "Q&A",
          activeCode: "community_qna",
        },
      },
      {
        // 커뮤니티 / Q&A
        path: "community/qna/:postId/reply",
        name: "project-community-qna-reply",
        component: () => import("@/views/community/CommunityQnaReply.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "Q&A" },
            { title: "답글", active: true },
          ],
          pageTitle: "Q&A",
          activeCode: "community_qna",
        },
      },
      {
        path: "community/healthinfo",
        name: "project-community-healthinfo",
        component: () => import("@/views/community/CommunityHealthInfo.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "안전보건 주요 일정" },
            { title: "목록", active: true },
          ],
          pageTitle: "안전보건 주요 일정",
          activeCode: "community_healthinfo",
        },
      },
      {
        // 커뮤니티 / 안전보건 주요 일정
        path: "community/healthinfo/create",
        name: "project-community-healthinfo-create",
        component: () => import("@/views/community/CommunityHealthInfoCreate.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "안전보건 주요 일정" },
            { title: "작성", active: true },
          ],
          pageTitle: "안전보건 주요 일정",
          activeCode: "community_healthinfo",
        },
      },
      {
        // 커뮤니티 / 안전보건 주요 일정
        path: "community/healthinfo/:postId",
        name: "project-community-healthinfo-detail",
        component: () => import("@/views/community/CommunityHealthInfoDetail.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "안전보건 주요 일정" },
            { title: "상세", active: true },
          ],
          pageTitle: "안전보건 주요 일정",
          activeCode: "community_healthinfo",
        },
      },
      {
        // 커뮤니티 / 안전보건 주요 일정
        path: "community/healthinfo/:postId/update",
        name: "project-community-healthinfo-update",
        component: () => import("@/views/community/CommunityHealthInfoUpdate.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "안전보건 주요 일정" },
            { title: "수정", active: true },
          ],
          pageTitle: "안전보건 주요 일정",
          activeCode: "community_healthinfo",
        },
      },
      {
        // 커뮤니티 / 안전보건 주요 일정
        path: "community/healthinfo/:postId/reply",
        name: "project-community-healthinfo-reply",
        component: () => import("@/views/community/CommunityHealthInfoReply.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "안전보건 주요 일정" },
            { title: "답글", active: true },
          ],
          pageTitle: "안전보건 주요 일정",
          activeCode: "community_healthinfo",
        },
      },
      {
        path: "community/unitbusinessnews",
        name: "project-community/unitbusinessnews",
        component: () => import("@/views/community/CommunityUnitBusinessNews.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "구성원 요청사항" },
            { title: "목록", active: true },
          ],
          pageTitle: "구성원 요청사항",
          activeCode: "community_unitbusinessnews",
        },
      },
      {
        // 커뮤니티 / 구성원 요청사항
        path: "community/unitbusinessnews/create",
        name: "project-community-unitbusinessnews-create",
        component: () => import("@/views/community/CommunityUnitBusinessNewsCreate.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "구성원 요청사항" },
            { title: "작성", active: true },
          ],
          pageTitle: "구성원 요청사항",
          activeCode: "community_unitbusinessnews",
        },
      },
      {
        // 커뮤니티 / 구성원 요청사항
        path: "community/unitbusinessnews/:postId",
        name: "project-community-unitbusinessnews-detail",
        component: () => import("@/views/community/CommunityUnitBusinessNewsDetail.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "구성원 요청사항" },
            { title: "상세", active: true },
          ],
          pageTitle: "구성원 요청사항",
          activeCode: "community_unitbusinessnews",
        },
      },
      {
        // 커뮤니티 / 구성원 요청사항
        path: "community/unitbusinessnews/:postId/update",
        name: "project-community-unitbusinessnews-update",
        component: () => import("@/views/community/CommunityUnitBusinessNewsUpdate.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "구성원 요청사항" },
            { title: "수정", active: true },
          ],
          pageTitle: "구성원 요청사항",
          activeCode: "community_unitbusinessnews",
        },
      },
      {
        // 커뮤니티 / 구성원 요청사항
        path: "community/unitbusinessnews/:postId/reply",
        name: "project-community-unitbusinessnews-reply",
        component: () => import("@/views/community/CommunityUnitBusinessNewsReply.vue"),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "커뮤니티" },
            { title: "구성원 요청사항" },
            { title: "답글", active: true },
          ],
          pageTitle: "안전보건 주요 일정",
          activeCode: "community_unitbusinessnews",
        },
      },
      {
        // 마이페이지 / 설정 / 개인정보변경
        path: "mypage/info-update",
        name: "project-mypage-info-update",
        component: () => import("@/views/mypage/MyPageInfoUpdate.vue"),
        meta: {
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "마이페이지" },
            { title: "설정" },
            { title: "개인정보변경", active: true },
          ],
          pageTitle: "개인정보변경",
          activeCode: "project-mypage-info-update",
        },
      },
      {
        // 마이페이지 / 설정 / 개인서명관리
        path: "mypage/sign-update",
        name: "project-mypage-sign-update",
        component: () => import("@/views/mypage/MyPageSignUpdate.vue"),
        meta: {
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "마이페이지" },
            { title: "설정" },
            { title: "개인서명관리", active: true },
          ],
          pageTitle: "개인서명관리",
          activeCode: "project-mypage-sign-update",
        },
      },
      {
        // 마이페이지 / 설정 / 기본문서관리
        path: "mypage/document-update",
        name: "project-mypage-sign-update",
        component: () => import("@/views/mypage/MyPageDocumentUpdate.vue"),
        meta: {
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "마이페이지" },
            { title: "설정" },
            { title: "기본문서관리", active: true },
          ],
          pageTitle: "기본문서관리",
          activeCode: "project-mypage-document-update",
        },
      },
      {
        // 마이페이지 / 업무현황
        path: "mypage/workstatus",
        name: "project-mypage-workstatus",
        component: () => import("@/views/mypage/MyPageWorkStatus.vue"),
        meta: {
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "마이페이지" },
            { title: "업무현황", active: true },
          ],
          pageTitle: "업무현황",
          activeCode: "project-mypage-workstatus",
        },
      },
      {
        // 마이페이지 / 알림
        path: "mypage/alert",
        name: "project-mypage-alert",
        component: () => import("@/views/mypage/MyPageAlert.vue"),
        meta: {
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "마이페이지" },
            { title: "알림", active: true },
          ],
          pageTitle: "알림",
          activeCode: "project-mypage-alert",
        },
      },
      {
        path: "approval-request",
        name: "project-approval-request",
        component: () => import("@/views/approval/ApprovalRequest.vue"),
        meta: {
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "마이페이지" },
            { title: "결재관리" },
            {
              title: "결재요청함",
              url: { name: "project-approval-request" },
              active: true,
            },
          ],
          pageTitle: "결재요청함",
        },
      },
      {
        path: "approval-await",
        name: "project-approval-await",
        component: () => import("@/views/approval/ApprovalAwait.vue"),
        meta: {
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "마이페이지" },
            { title: "결재관리" },
            {
              title: "결재대기함",
              url: { name: "project-approval-await" },
              active: true,
            },
          ],
          pageTitle: "결재대기함",
        },
      },
      {
        path: "approval-process",
        name: "project-approval-process",
        component: () => import("@/views/approval/ApprovalProcess.vue"),
        meta: {
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "마이페이지" },
            { title: "결재관리" },
            {
              title: "결재진행함",
              url: { name: "project-approval-process" },
              active: true,
            },
          ],
          pageTitle: "결재진행함",
        },
      },
      {
        path: "approval-complete",
        name: "project-approval-complete",
        component: () => import("@/views/approval/ApprovalComplete.vue"),
        meta: {
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "마이페이지" },
            { title: "결재관리" },
            {
              title: "완료문서함",
              url: { name: "project-approval-complete" },
              active: true,
            },
          ],
          pageTitle: "완료문서함",
        },
      },
      {
        path: "approval-reject",
        name: "project-approval-reject",
        component: () => import("@/views/approval/ApprovalReject.vue"),
        meta: {
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "마이페이지" },
            { title: "결재관리" },
            {
              title: "반려문서함",
              url: { name: "project-approval-reject" },
              active: true,
            },
          ],
          pageTitle: "반려문서함",
        },
      },
      {
        path: "approval-reference",
        name: "project-approval-reference",
        component: () => import("@/views/approval/ApprovalReference.vue"),
        meta: {
          breadcrumb: [
            {
              title: "home",
              url: "/home",
            },
            { title: "마이페이지" },
            { title: "결재관리" },
            {
              title: "참조/회람문서함",
              url: { name: "project-approval-reference" },
              active: true,
            },
          ],
          pageTitle: "참조/회람문서함",
        },
      },
    ],
  },
];
